<opac-dialog
  [open]="open"
  [title]="title"
  (closed)="cancel.emit()"
>
  <ng-content></ng-content>

  <div slot="actions">
    <opac-button *ngIf="cancelLabel !== undefined" type="tertiary" (click)="cancel.emit()">{{ cancelLabel | translate }}</opac-button>
    <opac-button *ngIf="acceptLabel !== undefined" (click)="accept.emit()">{{ acceptLabel | translate }}</opac-button>
  </div>
</opac-dialog>
